import { withSentryErrorReporting } from '@components/Fallback'
import { PageLoader } from '@components/Loader/PageLoader'
import { core, firebaseClientInitConfig } from '@lib/firebase/config'
import tenantManager from '@lib/firebase/tenantManager'
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

const AuthRouteComponent = () => <Outlet />

export const Route = createFileRoute('/_auth')({
  component: AuthRouteComponent,
  pendingMs: 500,
  pendingMinMs: 1500,
  pendingComponent: () => <PageLoader />,
  beforeLoad: async ({ context, location }) => {
    const { auth } = context

    const redirectUrl = tenantManager.isCurrentTenant(
      firebaseClientInitConfig.tenantIds.staff
    )
      ? core.staffAuthPageUrl
      : core.authPageUrl

    if (!auth) {
      // eslint-disable-next-line @typescript-eslint/no-throw-literal
      throw redirect({
        to: redirectUrl,
        search: { redirect: location.href },
      })
    }

    const { loading, user } = auth
    if (loading) {
      return <PageLoader />
    }

    if (!user) {
      // eslint-disable-next-line @typescript-eslint/no-throw-literal
      throw redirect({
        to: redirectUrl,
        search: { redirect: location.href },
      })
    }

    return <Outlet />
  },
  errorComponent: () => withSentryErrorReporting(<PageLoader />),
})
